//解决方案
let childRoutes = [
  {
    path: '/solution',
    name: 'solution',
    component: () => import('@/pages/solution/solution'),
  }
  // {
  //   path: '/controlPlatform',
  //   name: 'controlPlatform',
  //   component: () => import('@/pages/solution/controlPlatform'),
  // },
  // {
  //   path: '/solutionCHS',
  //   name: 'solutionCHS',
  //   component: () => import('@/pages/solution/solutionCHS'),
  // },
  // {
  //   path: '/dataSolution',
  //   name: 'dataSolution',
  //   component: () => import('@/pages/solution/dataSolution'),
  // }
 ];
export default childRoutes;



// WEBPACK FOOTER //
// ./src/router/module/solution.js